import { useState } from "react";
import { useApi } from "../useApi.js";
import { api, euro, nf, dateDe } from "../api.js";
import type { OrderRow } from "../types.js";
import { Page, Pill } from "../components/Shell.js";
import { TableSkeleton } from "../components/Skeleton.js";
import { toast } from "../toast.js";

export default function Orders() {
  const { data, error, loading, reload } = useApi<OrderRow[]>("/api/orders");
  const [busy, setBusy] = useState<string | null>(null);

  async function receive(id: string) {
    setBusy(id);
    try { await api.post(`/api/orders/${id}/receive`); await reload(); toast("Wareneingang gebucht", "success"); }
    catch (e) { toast(e instanceof Error ? e.message : "Buchung fehlgeschlagen", "error"); }
    finally { setBusy(null); }
  }

  return (
    <Page title="Bestellungen"
          sub={data ? `${data.length} Bestellungen · ${data.filter((o) => o.state !== "DELIVERED").length} in Zulauf` : undefined}>
      {loading && <div className="card"><TableSkeleton /></div>}
      {error && <div className="empty">{error}</div>}
      {data && data.length === 0 && <div className="card"><div className="empty">Noch keine Bestellung ausgelöst.</div></div>}
      <div className="grid" style={{ gap: 14 }}>
        {(data ?? []).map((o) => (
          <div className="card" key={o.id}>
            <div className="card-h">
              <h3 className="mono">{o.orderNo}</h3>
              {o.isAuto && <Pill status="info">Automatischer Vorschlag</Pill>}
              <Pill status={o.state === "DELIVERED" ? "OK" : "mute"}>
                {o.state === "DELIVERED" ? "Geliefert" : "Beauftragt"}
              </Pill>
              <div className="spacer" />
              <span className="sub-t num">{dateDe(o.placedAt)}</span>
              <b className="num" style={{ fontFamily: "var(--f-display)", fontSize: 16 }}>{euro(o.totalCents)}</b>
              {o.state !== "DELIVERED" && (
                <button className="btn sm" disabled={busy === o.id} onClick={() => void receive(o.id)}>
                  {busy === o.id ? "…" : "Wareneingang buchen"}
                </button>
              )}
            </div>
            <div className="tbl-wrap"><table><tbody>
              {o.items.map((i) => (
                <tr key={i.partId}>
                  <td><b>{i.name}</b><div className="sub-t mono">Pos. {i.sku}</div></td>
                  <td className="r num">{nf(i.qty)} St.</td>
                  <td className="r num">{euro(i.unitPriceCents)}</td>
                  <td className="r num">{euro(i.totalCents)}</td>
                </tr>
              ))}
            </tbody></table></div>
          </div>
        ))}
      </div>
    </Page>
  );
}
